import axios from 'axios';
import { API_ENDPOINTS } from '../config/api';

interface UserData {
  id: number;
  name: string;
  surname: string;
  phone_number: string;
  identification_number: string;
  management: string;
  office: string;
  authorization_level: 'Admin' | 'User';
}

export async function getUsers(): Promise<UserData[]> {
  const res = await axios.get(API_ENDPOINTS.users);
  return res.data;
}

export async function addUser(user: Omit<UserData, 'id'>): Promise<UserData> {
  const res = await axios.post(API_ENDPOINTS.users, user);
  return res.data;
}

export async function updateUser(
  user: Partial<UserData> & { id: string | number }
): Promise<UserData> {
  const res = await axios.put(`${API_ENDPOINTS.users}/${user.id}`, user);
  return res.data;
}

export async function deleteUser(id: string | number): Promise<void> {
  const res = await axios.delete(`${API_ENDPOINTS.users}/${id}`);
  return res.data;
}
